import { jsx as _jsx } from "react/jsx-runtime";
import { Label as LabelPrimitive } from "radix-ui";
import { cn } from "../../lib/cn";
/**
 * A form label, measured from `.fld > span`: mono, 10px, `0.12em` tracking,
 * uppercase, dim.
 *
 * Radix's Label is used rather than a bare `<label>` because it also forwards
 * a click to the control when the two are associated by `htmlFor`, and it
 * suppresses the text selection that a double click on a label otherwise
 * produces.
 */
export function Label({ className, ...props }) {
    return (_jsx(LabelPrimitive.Root, { "data-slot": "label", className: cn("lg:font-label lg:text-label lg:font-medium lg:uppercase lg:text-subtle", "lg:select-none lg:peer-disabled:cursor-not-allowed lg:peer-disabled:opacity-50", className), ...props }));
}
//# sourceMappingURL=label.js.map